function PasswordCtrl($auth, $scope, $state, $location, toaster, $stateParams, PasswordService, CommonService){
  'ngInject';
  const vm = this;
  vm.email = '';
  vm.baseUrl = 'http://' + $location.host() + ':' + $location.port();
  vm.redirectPath = vm.baseUrl +'/reset-password';
  vm.passwordForm = {};

  vm.header = {
    client: $stateParams.client_id,
    'access-token': $stateParams.token_hash,
    uid: $stateParams.uid
  };

  vm.sendEmail = function () {
    vm.submitted= true;
    PasswordService.sendEmail(vm.email, vm.redirectPath, function(response){
      if (response.data.errors) {
        toaster.pop('error', response.data.errors[0]);
      }
      else if (response.data.success){
        toaster.pop('info', 'Reset password link has been sent to your email address');
        $state.go('login', {inherit: false})
      }
      vm.email = '';
      $scope.emailForm.$setPristine();
      $scope.emailForm.$setUntouched();
    });
    }

  vm.resetPassword = function(){
    vm.submitted = true;
    PasswordService.resetPassword(vm.passwordForm, vm.header, function(response) {
      if (response.data.errors) {
        toaster.pop('error', CommonService.throwError(response));
      }
      else if (response.data.success){
        toaster.pop('info', 'New password updated.');
        $state.go('user.organization.dashboard.bulk', {inherit: false});
      }
      vm.passwordForm = {};
      $scope.pwdForm.$setPristine();
      $scope.pwdForm.$setUntouched();
    });
  }
  };

export default {
  name: 'PasswordCtrl',
  fn: PasswordCtrl
};
